import axios from 'axios';

// import router from '@/router';
import auth from '@/utils/auth';

import {
  GET_LINKS,
  GET_LINKS_ERROR,
  GET_LINKS_SUCCESS,

  GET_LINK,
  GET_LINK_ERROR,
  GET_LINK_SUCCESS,

  SAVE_LINK,
  SAVE_LINK_ERROR,
  SAVE_LINK_SUCCESS,

  DELETE_LINK,
  DELETE_LINK_ERROR,
  DELETE_LINK_SUCCESS,
} from './constants';

export default {

  async [DELETE_LINK]({ commit }, data) {
    try {
      commit(DELETE_LINK);
      await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/syndicate-addition-links/${data.linkID}`,
        method: 'DELETE',
        headers: auth.getAuthHeader(),
      });
      commit(DELETE_LINK_SUCCESS);
    } catch (err) {
      commit(DELETE_LINK_ERROR, err);
    }
  },

  async [GET_LINKS]({ commit }, syndicateID) {
    try {
      commit(GET_LINKS);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${syndicateID}/syndicate-addition-links`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_LINKS_SUCCESS, response.data);
    } catch (err) {
      commit(GET_LINKS_ERROR, err);
    }
  },

  async [GET_LINK]({ commit }, data) {
    try {
      commit(GET_LINK);
      const response = await axios({
        url: `${process.env.API_URL}/api/syndicates/${data.syndicateID}/syndicate-addition-links/${data.linkID}`,
        method: 'GET',
        headers: auth.getAuthHeader(),
      });
      commit(GET_LINK_SUCCESS, response.data);
    } catch (err) {
      commit(GET_LINK_ERROR, err);
    }
  },

  async [SAVE_LINK]({ commit }, data) {
    // const { agm, rowIndex } = data;
    try {
      commit(SAVE_LINK);
      let url = `${process.env.API_URL}/api/syndicates/${data.syndicateID}/syndicate-addition-links`;
      let method = 'POST';
      if (data.syndicateLinkId) {
        url = `${url}/${data.syndicateLinkId}`;
        method = 'PUT';
      }
      const response = await axios({
        url,
        method,
        headers: auth.getAuthHeader(),
        data,
      });
      commit(SAVE_LINK_SUCCESS, response.data);
    } catch (err) {
      commit(SAVE_LINK_ERROR, err);
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/Syndicates/Syndicate/Links/actions.js